import { ChangeEvent } from 'react';
import { TriggerFieldInputProps } from '../types';
import { ExCheckbox, ExInput, ExTextarea } from '@boomi/exosphere';

const ExoField = ({
    option,
    id,
    value,
    onChange,
    type,
    showValidation,
    validationMessage,
}: TriggerFieldInputProps) => {
    if (option.type === 'Boolean') {
        return (
            <ExCheckbox
                data-testid={option.id}
                className="exo-checkbox-input"
                id={id + option.id}
                input-id={id + option.id}
                size="large"
                value={value as boolean}
                onChange={(e: ChangeEvent) =>
                    onChange(option.id, (e.currentTarget as HTMLInputElement).checked)
                }
            >
                {option.label}
            </ExCheckbox>
        );
    }

    if (option.type === 'StringMultiline') {
        return (
            <ExTextarea
                data-testid={option.id}
                label={option.label}
                help-text={option.help}
                error-msg={validationMessage && validationMessage}
                invalid={showValidation}
                required={option.isRequired}
                className="exo-text-input"
                id={id + option.id}
                input-id={id + option.id}
                size="large"
                flavor="default"
                removemarginbottom
                value={(value as string) ?? ''}
                onChange={(e: ChangeEvent) =>
                    onChange(option.id, (e.currentTarget as HTMLTextAreaElement).value)
                }
            />
        );
    }

    return (
        <ExInput
            data-testid={option.id}
            label={option.label}
            help-text={option.help}
            error-msg={validationMessage}
            invalid={showValidation && validationMessage}
            required={option.isRequired}
            className="exo-text-input"
            id={id + option.id}
            input-id={id + option.id}
            type={type}
            inputmode={type === 'number' ? 'numeric' : type}
            size="default"
            flavor="default"
            removemarginbottom
            // ExInput has no autoComplete property
            value={(value as string) ?? ''}
            onChange={(e: ChangeEvent) =>
                onChange(option.id, (e.currentTarget as HTMLInputElement).value)
            }
        />
    );
};

export default ExoField;
